import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCreate = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14.5423 0.747314H11.8001V3.17002H9.375V5.91221H11.8001V8.3356H14.5423V5.91221H16.9633V3.17002H14.5423V0.747314ZM20 12.2904V10.6833V7.82551H17.1555V10.6833H7.14062V3.36145C7.14062 3.02993 7.00893 2.71199 6.77451 2.47757C6.54009 2.24315 6.22215 2.11145 5.89062 2.11145H0V4.96848H4.29688V12.2904C4.29688 12.6219 4.42857 12.9398 4.66299 13.1742C4.89741 13.4087 5.21535 13.5404 5.54688 13.5404H18.75C19.0815 13.5404 19.3995 13.4087 19.6339 13.1742C19.8683 12.9398 20 12.6219 20 12.2904ZM19.9999 17.1277C20.0076 15.9468 19.0564 14.9833 17.8755 14.9756C16.6946 14.968 15.7311 15.9192 15.7234 17.1001C15.7158 18.281 16.667 19.2445 17.8479 19.2521C19.0288 19.2598 19.9923 18.3086 19.9999 17.1277ZM6.44896 19.2526C7.62988 19.2452 8.58119 18.2818 8.57377 17.1009C8.56635 15.92 7.60301 14.9687 6.42209 14.9761C5.24118 14.9835 4.28987 15.9469 4.29729 17.1278C4.30471 18.3087 5.26805 19.26 6.44896 19.2526Z",
		fill: "auto"
	})
});
export default SvgCreate;
